import { CreateTable } from "./CreateTable";
import { tableData as classic } from "./TableData/Classic";
import { tableData as portes } from "./TableData/Portes";
import * as React from "react";
import { makeTournamentInfo } from "./TournamentInfo";
import { TableDataDefinition } from "../types";

export const BACKGAMMON_CLASSIC_ID = "backgammon_classic";
export const BACKGAMMON_PORTES_ID = "backgammon_portes";

const GameComponent = React.lazy(() => import("./Game"));

const makeDefinition = (game: string, tableData: TableDataDefinition) => ({
  tableData,
  CreateTableComponent: CreateTable,
  GameComponent,
  TournamentInfoComponent: makeTournamentInfo(game),
});

const DEFINITIONS = {
  backgammon_classic: classic,
  backgammon_portes: portes,
};

const GameConfig = Object.entries(DEFINITIONS).reduce(
  (prev, [key, value]) => ({ ...prev, [key]: makeDefinition(key, value) }),
  {}
);

export default GameConfig;
